import { useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useProductAnalytics } from '@/hooks/useProductAnalytics';

// Map routes to feature names
const ROUTE_FEATURES: Record<string, string> = {
  '/diagnostico': 'diagnostico',
  '/dashboard': 'dashboard',
  '/painel': 'painel_executivo',
  '/inteligencia': 'inteligencia',
  '/cardapio': 'cardapio',
  '/planos': 'planos',
  '/ajuda': 'ajuda',
  '/contadores': 'contadores',
};

// Using memo to prevent unnecessary re-renders and avoid ref warning
export const FeatureAdoptionTracker = memo(function FeatureAdoptionTracker() {
  const location = useLocation();
  const { trackPageView, trackFeatureUsage } = useProductAnalytics();

  useEffect(() => {
    const path = location.pathname;
    
    // Track page view
    trackPageView(path);

    // Track feature usage if it's a known feature route
    const featureName = ROUTE_FEATURES[path];
    if (featureName) {
      trackFeatureUsage(featureName);
    }
  }, [location.pathname, trackPageView, trackFeatureUsage]);

  return null;
});
